// extracted by mini-css-extract-plugin
export default {"imageWrapper":"VG-z","twoColumnImage":"WG-z"};